<template>
  <div ref="rootEl">
    <v-skeleton-loader
      v-if="loading"
      type="card"
      height="300"
    ></v-skeleton-loader>
    <v-card v-else class="pt-5 pb-6 px-6" rounded="lg" v-bind="cardAttrs">
      <div class="d-flex flex-column ga-3">
        <div class="d-flex align-center">
          <div class="text-body-1">{{ title }}</div>
          <v-btn
            v-if="exportFilename"
            class="rdrive-chart-export ms-auto my-n2"
            icon="mdi-download"
            variant="text"
            size="small"
            density="comfortable"
            :disabled="!hasDrawn"
            @click="downloadPng"
          />
        </div>
        <div class="d-flex" v-if="segments.length > 0">
          <v-sparkline
            v-for="(segment, i) in segments"
            :key="i"
            class="chart-segment"
            v-bind="segment"
            type="bar"
          />
        </div>
        <div v-else class="d-flex align-center justify-center" style="height: 40px;">
          <span class="text-body-2 text-medium-emphasis">{{ t('noData') }}</span>
        </div>
      </div>
      <v-list class="mt-3 legend-items" v-if="items.length > 0">
        <v-list-item
          v-for="(item, i) in items.filter(item => item.value > 0)"
          :key="item.id || i"
          class="px-2"
          density="compact"
          rounded="lg"
          tabindex="0"
          v-bind="legendAttrs(item)"
          @blur="blurSegments"
          @focus="focusSegment(item.id)"
          @mouseenter="focusSegment(item.id)"
          @mouseleave="blurSegments"
        >
          <template #prepend>
            <v-avatar class="mr-n2" :color="item.color" size="12" />
          </template>
          <template #title>
            <span class="text-body-2">{{ item.title }}</span>
          </template>
          <template #append>
            <v-chip class="percentage-chip" label size="x-small" :text="`${item.value.toFixed(1)}%`" />
          </template>
        </v-list-item>
      </v-list>
    </v-card>
  </div>
</template>

<script src="./model.js"></script>
<style scoped src="./style.css"></style>
